module.exports = __webpack_public_path__ + "static/Rosewater2-cacee45275049df50013feba061f46ed.png";